import { render, staticRenderFns } from "./HomeBanners.vue?vue&type=template&id=f54e02f0&scoped=true&"
import script from "./HomeBanners.vue?vue&type=script&lang=js&"
export * from "./HomeBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54e02f0",
  null
  
)

export default component.exports